import { useAppDispatch } from '@/redux/hooks'
import { useEffect } from 'react'
import { toggleDisabledSelector } from '@/redux/features/general-data/general-data-slice'

export function useToggleEcommerceSelector() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(toggleDisabledSelector())
    return () => {
      dispatch(toggleDisabledSelector())
    }
  }, [dispatch])
}
